var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmptyAppliances(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 358,
    height: 300,
    viewBox: "0 0 358 300",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 73,
    y: 40,
    width: 223,
    height: 12,
    rx: 2,
    fill: "#EEE"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 73,
    y: 8,
    width: 150,
    height: 20,
    rx: 2,
    fill: "#EEE"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    rx: 6,
    fill: "#EEE"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 73,
    y: 114,
    width: 223,
    height: 12,
    rx: 2,
    fill: "#EEE"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 73,
    y: 82,
    width: 150,
    height: 20,
    rx: 2,
    fill: "#EEE"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    y: 74,
    width: 60,
    height: 60,
    rx: 6,
    fill: "#EEE"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 73,
    y: 188,
    width: 223,
    height: 12,
    rx: 2,
    fill: "#EEE"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 73,
    y: 156,
    width: 150,
    height: 20,
    rx: 2,
    fill: "#EEE"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    y: 148,
    width: 60,
    height: 60,
    rx: 6,
    fill: "#EEE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#ostgfqy3xa)",
    d: "M-16-8h390v303H-16z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "ostgfqy3xa",
    x1: 179,
    y1: -114.739,
    x2: 179,
    y2: 219.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyAppliances);
export default __webpack_public_path__ + "static/media/empty_appliances.ff843c9506d34bce7a951d242897fbf9.svg";
export { ForwardRef as ReactComponent };